import { Component, HostListener, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService } from 'src/app/API.service';
import {
  localImages,
  stringsList,
  navigationConstants,
} from '../../dashboard/constants/app-config';
import { ClientService } from '../preview/invoices/services/client.service';
import { TrialContactDialogComponent } from './trial-contact-dialog/trial-contact-dialog.component';
import { log } from 'console';
import { SifrarnikDataService } from '../preview/sifrarnik/services/sifrarnik-data.service';

@Component({
  selector: 'app-left-toolbar',
  templateUrl: './left-toolbar.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./left-toolbar.component.css', '../styles/styles.css'],
})
export class LeftToolbarComponent implements OnInit {
  @Output() toggleMiniMode = new EventEmitter<boolean>();
  navigationConstants = navigationConstants;
  localImages = localImages;
  numberOfDaysLeftForTrial: any = null;
  dailiyScanLimit = 0;
  userID: any = null;
  toolbarHidden = false;
  isMiniMode = false;
  logoUrl: string = '/assets/logo 3.svg'; // Default fallback logo

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private clientService: ClientService,
    private apiService: APIService,
    public sifrarnikDataService: SifrarnikDataService,
    private route: ActivatedRoute
  ) {}

  toggleSidebar() {
    this.isMiniMode = !this.isMiniMode;
    this.toggleMiniMode.emit(this.isMiniMode);
  }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.toolbarHidden = params['toolbarHidden'] === 'true';
    });

    // Check if current route is 'fi-we' and enable mini mode
    if (this.router.url.includes('fi-we')) {
      this.isMiniMode = true;
      this.toggleMiniMode.emit(true);
    }

    // Subscribe to route changes
    this.router.events.subscribe((event) => {
      if (this.router.url.includes('fi-we')) {
        this.isMiniMode = true;
        this.toggleMiniMode.emit(true);
      }
    });
    
    this.userID = localStorage.getItem('userID');
    
    // Get logoUrl from localStorage
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        if (user.logoUrl) {
          this.logoUrl = user.logoUrl;
        }
      } catch (error) {
        console.error('Error parsing userInfo from localStorage:', error);
      }
    }
    
    await this.getUserStatus();
    if (
      this.numberOfDaysLeftForTrial !== null &&
      this.numberOfDaysLeftForTrial < 1
    ) {
      this.openTrialContactDialog(true);
    }
  }

  async getUserStatus() {
    //move it to private service
    console.log("getUserStatus: userID:" + this.userID);
    await this.clientService.GetClient(this.userID).then((res) => {
      if (res.status == 'TRIAL' && res.expirationDate) {
        this.numberOfDaysLeftForTrial = this.findDifferenceInDays(
          res.expirationDate
        );
      }
    });
  }

  findDifferenceInDays(expirationDate: any) {
    const givenDate = new Date(expirationDate);
    const today = new Date();

    // Calculate the difference in milliseconds between the two dates
    const differenceMs = givenDate.getTime() - today.getTime();

    // Convert the difference to days
    const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24)) + 1;
    return differenceDays;
  }

  logOut() {
    this.sifrarnikDataService.resetSifraData();
    localStorage.clear();
    this.router.navigate(['login']);
  }

  capitalizeFirstLetter(string: string) {
    if (string === 'invoices') return 'Documents'
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  openTrialContactDialog(isTrialEnded: any) {
    let data = {
      isTrialEnded: isTrialEnded,
      numberOfDaysLeftForTrial: this.numberOfDaysLeftForTrial,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '960px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = isTrialEnded;
    dialogConfig.panelClass = 'my-dialog-container';
    dialogConfig.data = data;

    const dialogRef = this.dialog.open(
      TrialContactDialogComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {});
  }

  redirectToOvewView(){
    this.router.navigate(['/overview']);
  }

  closeOverlay(event: any): void {
    event.preventDefault();
  }
}

